import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import loginReducer from './login';
import notificationReducer from './notification';
import skillsetReducer from './skillset';
import userProfileReducer from './userProfile';
import settingsReducer from './settings';
import builderPicsReducer from './builderPics';

const reducers = combineReducers({
  auth: loginReducer,
  form: formReducer,
  notification: notificationReducer,
  skillset: skillsetReducer,
  userProfile: userProfileReducer,
  settings: settingsReducer,
  builderPics: builderPicsReducer,
});

export default reducers;
